// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var PlayPauseBlanket = styled.div({
  width: '100%',
  height: '100%',
  cursor: 'pointer'
});
PlayPauseBlanket.displayName = 'PlayPauseBlanket';